(() => {
  'use strict';
  const q = (selector, root = document) => root.querySelector(selector);
  const qa = (selector, root = document) => [...root.querySelectorAll(selector)];
  const focusable = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  const backdrop = q('#ks-engagement-backdrop');
  const site = q('#r-site');
  const modal = q('#ks-signup-modal');
  let active = null;
  let returnFocus = null;
  let previousOverflow = '';
  let previousInert = false;

  const panel = name => name === 'signup' ? modal : q(`#ks-${name}-panel`);
  const close = (restore = true) => {
    if (!active) return;
    const closingName = active;
    const current = panel(active);
    active = null;
    if (current) current.hidden = true;
    if (backdrop) backdrop.hidden = true;
    document.body.style.overflow = previousOverflow;
    if (site) site.inert = previousInert;
    if (closingName === 'signup' && modal?.dataset.key) {
      try { window.sessionStorage.setItem(`ks-signup-dismissed-${modal.dataset.key}`, 'true'); } catch (_) { /* Storage can be blocked; closing still works. */ }
    }
    if (restore) {
      const target = returnFocus && returnFocus !== document.body && returnFocus.isConnected
        ? returnFocus
        : q('#MainContent') || site;
      target?.focus({ preventScroll: true });
    }
    returnFocus = null;
  };
  const open = (name, trigger = null) => {
    const current = panel(name);
    if (!current || !backdrop) return;
    close(false);
    active = name;
    returnFocus = trigger;
    previousOverflow = document.body.style.overflow;
    previousInert = Boolean(site?.inert);
    document.body.style.overflow = 'hidden';
    if (site) site.inert = true;
    backdrop.hidden = false;
    current.hidden = false;
    requestAnimationFrame(() => {
      const target = q('[data-ks-initial-focus]', current) || q(focusable, current);
      target?.focus({ preventScroll: true });
    });
  };

  qa('[data-ks-open]').forEach(button => button.addEventListener('click', () => open(button.dataset.ksOpen, button)));
  qa('[data-ks-close]').forEach(button => button.addEventListener('click', () => close()));
  backdrop?.addEventListener('click', close);
  document.addEventListener('keydown', event => {
    if (!active) return;
    if (event.key === 'Escape') { event.preventDefault(); close(); return; }
    if (event.key !== 'Tab') return;
    const nodes = qa(focusable, panel(active)).filter(node => node.getClientRects().length && !node.hasAttribute('hidden'));
    if (!nodes.length) { event.preventDefault(); panel(active)?.focus(); return; }
    const first = nodes[0], last = nodes[nodes.length - 1];
    if (event.shiftKey && (document.activeElement === first || !panel(active)?.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
    if (!event.shiftKey && (document.activeElement === last || !panel(active)?.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
  });

  if (!modal) return;
  const submitted = modal.dataset.submitted === 'true';
  const formHasErrors = modal.dataset.hasErrors === 'true';
  const enabled = modal.dataset.enabled === 'true';
  const delay = Math.max(0, Number.parseInt(modal.dataset.delay, 10) || 0);
  const storageKey = `ks-signup-dismissed-${modal.dataset.key || 'offer'}`;
  let dismissed = false;
  try { dismissed = window.sessionStorage.getItem(storageKey) === 'true'; } catch (_) { /* Storage can be blocked; the modal still works. */ }
  const isSuccess = submitted;
  const forcedByLink = new URLSearchParams(window.location.search).get('signup_offer') === '1';
  const discount = q('[data-ks-discount]', modal);
  if (discount && isSuccess && discount.dataset.code) discount.hidden = false;
  if (enabled && (isSuccess || formHasErrors || forcedByLink)) {
    open('signup');
  } else if (enabled && !dismissed) {
    window.setTimeout(() => {
      if (!active) open('signup');
    }, delay);
  }
  q('[data-ks-signup-close]', modal)?.addEventListener('click', () => close());
})();
/* Keep the support launcher clear of mobile purchase controls. */
(()=>{'use strict';
const float=document.querySelector('.ks-engagement-float--help');if(!float)return;
const launcher=float.querySelector('.ks-engagement-launcher'),help=document.querySelector('#ks-help-panel');
if(!launcher||!help)return;
const mobile=matchMedia('(max-width:600px)'),targets='[data-main-actions],.pg-five-express,.shopify-payment-button,shopify-accelerated-checkout,.pg-five-sticky,#six-purchase .actions,.dock:has(#six-dock-total),.pa-actions,.pa-dock,[data-purchase],[data-buy],[data-plain-add],[data-ks-add],[data-yr-add],.pg-pet-add,form[action*="/cart/add"] button[type="submit"]';
let queued=false,hidden=false;
const visible=e=>{const s=getComputedStyle(e);return !e.closest('[hidden]')&&s.display!=='none'&&s.visibility!=='hidden'&&e.getClientRects().length>0};
const intersects=(a,b)=>a.left<b.right&&a.right>b.left&&a.top<b.bottom&&a.bottom>b.top;
function update(){queued=false;
 // Never close an already-open support panel as a side effect of collision handling.
 const cart=document.querySelector('.pg-cart-drawer:not([hidden])');
 if(!help.hidden){set(false);return;}
 let collision=false;
 if(cart)collision=true;
 else if(mobile.matches&&document.body.dataset.page==='product'){
  const a=float.getBoundingClientRect();
  collision=[...document.querySelectorAll(targets)].some(e=>visible(e)&&intersects(a,e.getBoundingClientRect()));
 }
 set(collision);
}
function set(value){if(value===hidden)return;hidden=value;float.classList.toggle('ks-help-obscured',value);launcher.inert=value;}
function schedule(){if(!queued){queued=true;requestAnimationFrame(update)}}
window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule,{passive:true});
window.visualViewport?.addEventListener('resize',schedule,{passive:true});
const observer=new MutationObserver(schedule);observer.observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['hidden','class','style']});
schedule();
})();
